module.exports = __webpack_public_path__ + "img/6.4095be6.png";